

























import Login from '@/components/login/Login.vue';
import LoginHeader from '@/components/login/LoginHeader.vue';
import Footers from '@/components/Footers.vue';
import {Vue, Component} from 'vue-property-decorator';
import {I18N_LOCALE} from '@/const/words/cookie';
import { SecondAuthType, SecondCertType } from 'supporter';
import { setSessionCookie, setToken } from '@/utils/dataUtils';
import Cookies from 'js-cookie';
import {namespace} from 'vuex-class';
import {Admin} from '@/types';
const adminModule = namespace('admin');
@Component({
  components: {Login, LoginHeader, Footers}
})
export default class ExternalAccess extends Vue {
  @adminModule.Mutation('SET_MENUS') private setMenus!: (menus: any) => void;
  private smsSended = false;
  private smsAuthCode = '';
  onClickSmsAuthSendBtn(){
    const data = {
      type: 'SMS' as SecondCertType,
      certKey: this.$route.query.code as string,
      usage: 'LOGIN' as SecondAuthType,
    };
    this.$api.postAuthSecondaryCert({data}).then(res=>{
      this.smsSended = true
    })
  }
  onKeyUpSmsAuthCode(event:Event) {
    const {value} = event.target as HTMLInputElement;
    const AUTH_CODE_VALID_LENGTH = 6;
    const $authBtn = $('#external_access_auth_btn');

    if (value.length === AUTH_CODE_VALID_LENGTH) {
      $authBtn.removeAttr('disabled');
      $authBtn.removeClass('btn_fill_gray');
    } else {
      $authBtn.attr('disabled', 'disabled');
      $authBtn.addClass('btn_fill_gray');
    }
  }
  onClickExternalAccessAuthBtn() {
    if (!this.checkForm()) {
      return;
    }
    const data = {
      code: this.smsAuthCode,
      adminType: 'SERVICE',
      certKey: this.$route.query.code as string,
      type: 'SMS'as SecondCertType,
      usage: 'LOGIN' as SecondAuthType,
    };
    this.$api.putAuthSecondaryCert({data}).then(res=>{
      alert(this.$t('SECOND_CERT_SMS_SUCCES'));
      const {accessToken, refreshToken, autoLogoutMin } = res.data;
      const admin = setToken(accessToken, refreshToken, autoLogoutMin) as any as Admin;
      this.setMenus(null);
      setSessionCookie();

      let i18nLocale = 'kr';
      this.$api.getAdminsService({params: {searchType: 'ADMIN_ID', keyword: admin.id}}).then(({data})=>{
        let myAdmin = data.contents.find((tempAdmin) => tempAdmin.adminId === admin.id);
        if (myAdmin) {
          switch (myAdmin.language) {
            case 'CHINESE':
              i18nLocale = 'zh';
              break;
            case 'JAPANESE':
              i18nLocale = 'jp';
              break;
            case 'ENGLISH':
              i18nLocale = 'en';
              break;
            default:
              i18nLocale = 'kr';
              break;
          }
        }
        Cookies.set(I18N_LOCALE, i18nLocale);
        this.$i18n.locale = i18nLocale;

        this.$router.push('/');
      })
    })
  }
  checkForm() {
    if (!this.smsAuthCode) {
      alert(this.$t('SECOND_CERT_AUTH_CODE_INPUT'));
      return false;
    }

    return true;
  }
}
